// extracted by mini-css-extract-plugin
export default {"container":"FgLar","checkedContainer":"g5NzM FgLar","image":"PG_oL","name":"_BTD2","closeImage":"pEE_k"};